"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _warning = _interopRequireDefault(require("warning"));

function TextFormattedReplace(_ref) {
  var children = _ref.children,
      replaces = _ref.replaces;
  var parts = children.split('##');
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, parts.map(function (part, idx) {
    if (idx % 2 === 0) {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
        key: idx.toString()
      }, part);
    }

    process.env.NODE_ENV !== "production" ? (0, _warning.default)(typeof replaces[part] === 'function', "TextFormattedReplace: Replacer ".concat(part, " is not a function.")) : void 0;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
      key: idx.toString()
    }, replaces[part]());
  }));
}

process.env.NODE_ENV !== "production" ? TextFormattedReplace.propTypes = {
  children: _propTypes.default.string.isRequired,

  /**
   * Shape of replace renderers, `{[replKey: string]: () => JSX.Element}`.
   */
  replaces: _propTypes.default.shape({}).isRequired
} : void 0;
var _default = TextFormattedReplace;
exports.default = _default;